import type { TsCodeType } from '../../types.js'
import { LeafBlock } from '../leaf-block.js'
import { FormValidationRule } from './form-validation-rule.js'
import {
	jsonArrayProperty,
	jsonProperty,
} from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { Expression } from '../../data/text-or-code.js'
import { TextOrExpression_assumeExpression } from '../../data/text-or-code.js'
import { TextOrExpression_assumeText } from '../../data/text-or-code.js'

export const FormInputDisplayTypes = {
	formField: 'Form Field box with label',
	// labelOnLeftGrouped: 'Label on left side of input field (grouped)',
	// labelOnLeftSeparate: 'Label on left side of input field (separate; useful in grid layouts)',
	onlyInput: 'Only input field',
}
export type FormInputDisplayType = keyof typeof FormInputDisplayTypes

export abstract class FormInputBlock extends LeafBlock {
	@jsonProperty(TextOrExpression_assumeText)
	@ScreenEditorInput({
		inputType: 'code',
		order: 5,
		label: 'Hint',
		codeLanguage: 'ts',
		alternativeContentAreaName: 'hint',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
	})
	hintCode = new TextOrExpression_assumeText('', 'T')

	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'dropdown',
		order: 101,
		label: 'Display type',
		tab: 'Appearance',
		options: Object.entries(FormInputDisplayTypes),
	})
	displayType: FormInputDisplayType = 'formField'

	declare labelCode?: TextOrExpression_assumeExpression
	declare bindingCode?: Expression

	constructor() {
		super()
		this.validationRules = []
	}

	canHaveAppearance(): boolean {
		return true
	}

	canHaveValidators() {
		return true
	}
}
